var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendericon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.115,
    height: 13.461,
    viewBox: "0 0 12.115 13.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M296.769-303.654H296.1V-305H294.75v1.346h-5.385V-305h-1.346v1.346h-.673a1.34,1.34,0,0,0-1.339,1.346L286-292.885a1.346,1.346,0,0,0,1.346,1.346h9.423a1.35,1.35,0,0,0,1.346-1.346v-9.423a1.35,1.35,0,0,0-1.346-1.346Zm0,10.769h-9.423v-7.4h9.423v7.4Zm-8.077-6.058h3.365v3.365h-3.365Z",
    transform: "translate(-286 305)",
    fill: "#cacaca",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon);
export default __webpack_public_path__ + "static/media/calendericon.5f6493b128dd65467449617209c534bc.svg";
export { ForwardRef as ReactComponent };